module.exports = __webpack_public_path__ + "img/light--active.c7819e87.svg";